import styled from "styled-components";

const Style = styled.div`
  background: var(--base-gray-30);
  padding: 2px;
  border-radius: 4px;
  display: flex;

  .tab {
    padding: 4px 22px;
    border-radius: 4px;
    cursor: pointer;
    transition: .4s background, .4s box-shadow;

    &.active {
      background: white;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.03), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;

      label {
        cursor: not-allowed;
      }
    }

    label {
      margin: 0px;
      font-weight: 500;
      cursor: pointer;
    }
  }
`;

export default Style;
